import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const VibeSwipePage = lazy(() => import("../../pages/VibeSwipePage"));

export function MichaelYenRoutes() {
  return (
    <Switch>
      <Route path="/my/vibe-swipe" component={VibeSwipePage} />
    </Switch>
  );
}

export const slug = "my";
